import { render, staticRenderFns } from "./b-select.vue?vue&type=template&id=18fbbe42&scoped=true"
import script from "./b-select.vue?vue&type=script&lang=js"
export * from "./b-select.vue?vue&type=script&lang=js"
import style0 from "./b-select.vue?vue&type=style&index=0&id=18fbbe42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbbe42",
  null
  
)

export default component.exports